import { render, staticRenderFns } from "./ProductSort.vue?vue&type=template&id=7603432c&scoped=true"
import script from "./ProductSort.vue?vue&type=script&lang=js"
export * from "./ProductSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7603432c",
  null
  
)

export default component.exports